export const Arguments = {
	// 本地运行
	// 'host': 'http://localhost:8090',
	// 'reactUrl': 'http://localhost:3000/#',
	// 测试服务器 需要配 host
	// 'host': 'http://society.science.com:8150',
	// 'reactUrl': 'http://society.science.com:8081/#'
	// 正式部署
	'host': 'https://www.tjskw.org.cn',
	'reactUrl': 'https://www.tjskw.org.cn/skl_guanli/#',

	// 此外还需要修改 ImportTableModel.js 文件中的 templateUrl 地址，变成服务器静态文件的存放地址
};